module.exports = __webpack_public_path__ + "static/media/sidemenu.6956e75a.png";